// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { StatementResponse, PolicyService, readParameterFromRouterState, GoAction } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/core/services/alert.service';
import { Store } from '@ngrx/store';
import { PolicyStatementFacadeService } from '@app/access-management/state/policy-statement.facade';
import { PolicyDetailsFacadeService } from '@app/access-management/state/policy-details/policy-details.facade';

@Component({
    selector: 'app-policy-statements-list',
    templateUrl: './policy-statements-list.component.html'
})
export class PolicyStatementsListComponent {
    @Input() statements = [];
    policyId: string;

    constructor(
        private store: Store<any>,
        private modalService: NgbModal,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private policyStatementFacade: PolicyStatementFacadeService,
        private policyDetailsFacade: PolicyDetailsFacadeService,
        private policyService: PolicyService) {

        const policyId = readParameterFromRouterState(this.route, 'id');
        if (!policyId) {
          throw new Error('role id not in route');
        }
        this.policyId = policyId;

    }
    readonly columns = [
        { name: 'Effect', prop: 'effect' },
        { name: 'Service', prop: 'service_name' },
        { name: 'Resource', prop: 'resource_name' },
        { name: 'Actions', prop: 'action' }
      ];

      trackColumns(idx: number) {
        return idx;
      }

      oneEdit (row: any) {
          this.policyStatementFacade.clearPolicyForm();
          this.policyStatementFacade.setStatement(row, 0);
          this.store.dispatch(new GoAction(['/iam/policies', this.policyId, 'statement', row.statement_id]));
      }

      onRemove(statement: StatementResponse) {
        const ModalFixture = this.modalService.open(GeneralDeleteModalComponent, { centered: true, windowClass: 'no-border' });
        const modal: GeneralDeleteModalComponent = ModalFixture.componentInstance;
        modal.observable = this.policyService.deleteStatement(this.policyId, statement.statement_id);
        modal.onSuccessRemove = () => {
            this.alertService.success('Statement was removed successfully.');
            this.policyDetailsFacade.refreshPolicyDetails(this.policyId);
          modal.close();
        };
        modal.onFailRemove = () => {
            this.alertService.error('There was an error removing the statement.');
        };
      }

      addStatement () {
        this.policyStatementFacade.clearPolicyForm();
        this.policyStatementFacade.addNewStatement();
      }
}



// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/policy-details/policy-statements-list/policy-statements-list.component.ts